module.exports = __webpack_public_path__ + "img/appAsset-brand--b2brouter.8fcc70f4.svg";